var _a;
const u = up.util;
up.Change.FromURL = (_a = class FromURL extends up.Change {
        async execute() {
            let newPageReason = this._newPageReason();
            if (newPageReason) {
                up.puts('up.render()', newPageReason);
                up.network.loadPage(this.options);
                return u.unresolvablePromise();
            }
            let requestAttrs = this._getRequestAttrs();
            let request = this.request = up.request(requestAttrs);
            this.options.onRequestKnown?.(request);
            if (this.options.preload)
                return request;
            this.options.handleAbort({ request, ...requestAttrs });
            request.runPreviews(this.options);
            return await u.always(request, (responseOrError) => this._onRequestSettled(responseOrError));
        }
        _newPageReason() {
            if (u.isCrossOrigin(this.options.url)) {
                return 'Loading cross-origin content in new page';
            }
            if (this.options.history && !up.browser.canPushState()) {
                return 'Loading content in new page to restore history support';
            }
        }
        _getRequestAttrs() {
            const successAttrs = this._preflightPropsForRenderOptions(this.options);
            const failAttrs = this._preflightPropsForRenderOptions(this.deriveFailOptions(), { optional: true });
            return {
                ...this.options,
                ...successAttrs,
                ...u.withRenamedKeys(failAttrs, up.fragment.failKey),
            };
        }
        getPreflightProps() {
            return this._getRequestAttrs();
        }
        _preflightPropsForRenderOptions(renderOptions, getPreflightPropsOptions) {
            const preflightChange = new up.Change.FromContent({ ...renderOptions, preflight: true });
            return preflightChange.getPreflightProps(getPreflightPropsOptions);
        }
        _onRequestSettled(response) {
            if (response instanceof up.Response) {
                return this._onRequestSettledWithResponse(response);
            }
            else {
                return this._onRequestSettledWithError(response);
            }
        }
        _onRequestSettledWithResponse(response) {
            return new up.Change.FromResponse({ ...this.options, response }).execute();
        }
        _onRequestSettledWithError(error) {
            if (error instanceof up.Offline) {
                let log = ['Cannot load fragment from %s: %s', error.request.description, error.reason];
                this.request.emit('up:fragment:offline', {
                    callback: this.options.onOffline,
                    renderOptions: this.options,
                    retry: (retryOptions) => up.render({ ...this.options, ...retryOptions }),
                    log,
                });
            }
            throw error;
        }
    },
    (() => {
        u.memoizeMethod(_a.prototype, {
            _getRequestAttrs: true,
        });
    })(),
    _a);
